export default __webpack_public_path__ + "static/media/Mark-3-Suit-09.6c0808dd.jpg";